import React from "react";
import "./Card.css";

type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  padding?: "sm" | "md" | "lg";
  elevated?: boolean;
};

const paddingMap = {
  sm: "card--padding-sm",
  md: "card--padding-md",
  lg: "card--padding-lg",
};

const Card: React.FC<CardProps> = ({
  children,
  className = "",
  padding = "md",
  elevated,
  ...rest
}) => {
  const classes = [
    "card",
    paddingMap[padding],
    elevated ? "card--elevated" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

export default Card;
